/*! Bead Yours - Perler builder. Needs by-palette.js, by-core.js, by-templates-data.js, by-templates.js.
    Mount: <div data-by-perler> with an optional <script type="application/json" data-by-config> inside. */
(function (g) {
  'use strict';
  var BY = g.BeadYours = g.BeadYours || {};
  var h = BY.h;

  var BOARDS = [
    { id: '15', label: 'Mini', w: 15, h: 15, note: '3" square' },
    { id: '29', label: 'Classic', w: 29, h: 29, note: '5.7" - one board' },
    { id: '43', label: 'Big', w: 43, h: 43, note: '8.5" square' },
    { id: '58', label: 'Jumbo', w: 58, h: 58, note: '11.4" - four boards' },
    { id: '29x58', label: 'Tall', w: 29, h: 58, note: '5.7" x 11.4"' },
    { id: '58x29', label: 'Wide', w: 58, h: 29, note: '11.4" x 5.7"' }
  ];
  var DEFAULT_TIERS = [
    { name: 'Mini', max: 150 }, { name: 'Small', max: 400 }, { name: 'Medium', max: 841 },
    { name: 'Large', max: 1700 }, { name: 'XL', max: 3400 }, { name: 'Jumbo', max: 7600 }
  ];
  var DEFAULT_ADDONS = [
    { key: 'keychain', label: 'Keychain ring' }, { key: 'magnet', label: 'Magnet back' },
    { key: 'pin', label: 'Pin back' }, { key: 'stand', label: 'Display stand' }, { key: 'hanger', label: 'Hanging cord' }
  ];
  var MAX_SIDE = 87, MIN_BEADS = 6;

  var ICONS = {
    draw: '<svg viewBox="0 0 24 24"><path d="M4 20l4-1 11-11-3-3L5 16l-1 4z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>',
    erase: '<svg viewBox="0 0 24 24"><path d="M8 20h12M4 15l9-9 6 6-7 7H9z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>',
    fill: '<svg viewBox="0 0 24 24"><path d="M5 11l7-7 7 7-7 7z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M20 15c1 2 1 3 0 4s-2 0-2-1 1-2 2-3z" fill="currentColor"/></svg>',
    pick: '<svg viewBox="0 0 24 24"><path d="M14 4l6 6-2 2-6-6zM12 8l-7 7v4h4l7-7" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>',
    mirror: '<svg viewBox="0 0 24 24"><path d="M12 3v18M9 7L4 12l5 5V7zM15 7l5 5-5 5V7z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>',
    undo: '<svg viewBox="0 0 24 24"><path d="M9 7L4 12l5 5M4 12h11a5 5 0 010 10h-3" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    redo: '<svg viewBox="0 0 24 24"><path d="M15 7l5 5-5 5M20 12H9a5 5 0 000 10h3" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    clear: '<svg viewBox="0 0 24 24"><path d="M5 7h14M10 7V4h4v3M7 7l1 13h8l1-13" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>',
    plus: '<svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>',
    minus: '<svg viewBox="0 0 24 24"><path d="M5 12h14" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>',
    fit: '<svg viewBox="0 0 24 24"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    eye: '<svg viewBox="0 0 24 24"><circle cx="8" cy="8" r="3.2" fill="currentColor"/><circle cx="16" cy="8" r="3.2" fill="currentColor" opacity=".6"/><circle cx="8" cy="16" r="3.2" fill="currentColor" opacity=".6"/><circle cx="16" cy="16" r="3.2" fill="currentColor"/></svg>'
  };
  function icon(name) { var s = h('span', { class: 'by-ic', 'aria-hidden': 'true' }); s.innerHTML = ICONS[name] || ''; return s; }

  function PerlerBuilder(root, cfg) {
    this.root = root;
    this.cfg = Object.assign({
      productHandle: 'custom-perler-design', addonsHandle: 'perler-add-ons', tiers: DEFAULT_TIERS,
      addons: DEFAULT_ADDONS, enabledColors: null, allowAllColors: false, afterAdd: 'cart', patternUrl: null,
      defaultBoard: '29', shareDefault: false
    }, cfg || {});
    // theme editor friendly text settings: "Mini:150, Small:400" and "Keychain ring, Magnet back"
    if (typeof this.cfg.tiersText === 'string' && this.cfg.tiersText.trim()) {
      var tiers = this.cfg.tiersText.split(',').map(function (x) { return x.split(':'); }).filter(function (p) { return p.length === 2; })
        .map(function (p) { return { name: p[0].trim(), max: parseInt(p[1], 10) }; }).filter(function (t) { return t.name && t.max > 0; });
      if (tiers.length) this.cfg.tiers = tiers.sort(function (a, b) { return a.max - b.max; });
    }
    if (typeof this.cfg.addonsText === 'string') {
      this.cfg.addons = this.cfg.addonsText.split(',').map(function (x) { return x.trim(); }).filter(Boolean)
        .map(function (label) { return { key: label.toLowerCase().replace(/[^a-z0-9]+/g, '-'), label: label }; });
    }
    if (this.cfg.enabledColors && !this.cfg.enabledColors.filter(Boolean).length) this.cfg.enabledColors = null;
    this.palette = BY.enabledPerler(this.cfg.enabledColors);
    this.allColors = this.cfg.allowAllColors ? BY.allCurrentPerler() : this.palette;
    var b = BOARDS.filter(function (x) { return x.id === this.cfg.defaultBoard; }, this)[0] || BOARDS[1];
    this.w = b.w; this.h = b.h; this.grid = new Uint8Array(this.w * this.h);
    this.color = (this.palette.filter(function (c) { return c.code === 'P05'; })[0] || this.palette[0]).id;
    this.tool = 'draw'; this.mirror = 'off'; this.view = 'beads';
    this.zoom = 1; this.panX = 0; this.panY = 0;
    this.undoStack = []; this.redoStack = [];
    this.name = ''; this.share = !!this.cfg.shareDefault; this.addonsOn = {};
    this.products = { main: null, addons: null };
    this.recent = [];
    this.build();
    this.restore();
    this.loadProducts();
    this.resize();
  }
  var P = PerlerBuilder.prototype;

  /* ---------------------------------------------------------------- UI */
  P.build = function () {
    var self = this, root = this.root;
    root.classList.add('by-app', 'by-perler');
    root.innerHTML = '';
    // header
    this.nameInput = h('input', { class: 'by-input by-name', type: 'text', maxlength: '40', placeholder: 'Name your design (optional)', 'aria-label': 'Design name',
      oninput: function () { self.name = this.value; self.save(); } });
    this.boardSel = h('select', { class: 'by-select', 'aria-label': 'Board size', onchange: function () { self.onBoardChange(this.value); } });
    BOARDS.forEach(function (b) { self.boardSel.appendChild(h('option', { value: b.id, text: b.label + ' - ' + b.w + 'x' + b.h + ' (' + b.note + ')' })); });
    self.boardSel.appendChild(h('option', { value: 'custom', text: 'Custom size...' }));
    var header = h('div', { class: 'by-head' }, [this.nameInput, this.boardSel]);

    // stage
    this.canvas = h('canvas', { class: 'by-canvas', 'aria-label': 'Bead design board. Tap or drag to place beads.' });
    this.ctx = this.canvas.getContext('2d');
    var zoomIn = h('button', { class: 'by-fab', type: 'button', 'aria-label': 'Zoom in', onclick: function () { self.zoomBy(1.4); } }, [icon('plus')]);
    var zoomOut = h('button', { class: 'by-fab', type: 'button', 'aria-label': 'Zoom out', onclick: function () { self.zoomBy(1 / 1.4); } }, [icon('minus')]);
    var fit = h('button', { class: 'by-fab', type: 'button', 'aria-label': 'Fit board', onclick: function () { self.fit(); } }, [icon('fit')]);
    this.viewBtn = h('button', { class: 'by-fab', type: 'button', 'aria-label': 'Switch bead / pixel view', onclick: function () { self.view = self.view === 'beads' ? 'pixels' : 'beads'; self.draw(); } }, [icon('eye')]);
    this.stage = h('div', { class: 'by-stage' }, [this.canvas, h('div', { class: 'by-fabs' }, [zoomIn, zoomOut, fit, this.viewBtn])]);
    this.info = h('div', { class: 'by-stage-info', 'aria-live': 'polite' });

    // tools
    this.toolBtns = {};
    var tools = h('div', { class: 'by-tools', role: 'toolbar', 'aria-label': 'Tools' });
    [['draw', 'Draw'], ['erase', 'Erase'], ['fill', 'Fill'], ['pick', 'Pick color']].forEach(function (t) {
      var b = h('button', { class: 'by-tool', type: 'button', 'aria-pressed': 'false', title: t[1], onclick: function () { self.setTool(t[0]); } }, [icon(t[0]), h('span', { text: t[1] })]);
      self.toolBtns[t[0]] = b; tools.appendChild(b);
    });
    this.mirrorBtn = h('button', { class: 'by-tool', type: 'button', title: 'Mirror drawing', onclick: function () { self.cycleMirror(); } }, [icon('mirror'), h('span', { text: 'Mirror' })]);
    tools.appendChild(this.mirrorBtn);
    tools.appendChild(h('button', { class: 'by-tool', type: 'button', title: 'Undo', onclick: function () { self.undo(); } }, [icon('undo'), h('span', { text: 'Undo' })]));
    tools.appendChild(h('button', { class: 'by-tool', type: 'button', title: 'Redo', onclick: function () { self.redo(); } }, [icon('redo'), h('span', { text: 'Redo' })]));
    tools.appendChild(h('button', { class: 'by-tool', type: 'button', title: 'Clear board', onclick: function () { self.confirm('Clear the whole board?', 'Clear', function () { self.snapshot(); self.grid.fill(0); self.changed(); }); } }, [icon('clear'), h('span', { text: 'Clear' })]));

    // palette
    this.paletteEl = h('div', { class: 'by-palette', role: 'listbox', 'aria-label': 'Bead colors' });
    this.colorLabel = h('div', { class: 'by-color-label' });
    this.renderPalette();

    // tabs
    this.tabs = {};
    var tabBar = h('div', { class: 'by-tabs', role: 'tablist' });
    this.panel = h('div', { class: 'by-panel', role: 'tabpanel' });
    [['templates', 'Templates'], ['pets', 'Pet maker'], ['text', 'Names & text'], ['photo', 'Photo']].forEach(function (t) {
      var b = h('button', { class: 'by-tab', type: 'button', role: 'tab', 'aria-selected': 'false', text: t[1], onclick: function () { self.openTab(t[0]); } });
      self.tabs[t[0]] = b; tabBar.appendChild(b);
    });

    // checkout bar
    this.priceEl = h('div', { class: 'by-price' });
    this.metaEl = h('div', { class: 'by-meta' });
    this.addonsEl = h('div', { class: 'by-addons' });
    this.shareUI = BY.shareBlock(this, function () { self.save(); }, 'by-share-');
    var shareLbl = this.shareUI.el;
    this.addBtn = h('button', { class: 'by-btn by-btn--primary by-add', type: 'button', text: 'Add to cart', onclick: function () { self.addToCart(); } });
    this.renderAddons();
    var finish = h('div', { class: 'by-finish' }, [h('div', { class: 'by-finish-title', text: 'Finishing touches' }), this.addonsEl, shareLbl]);
    var bar = h('div', { class: 'by-bar' }, [
      h('div', { class: 'by-bar-sum' }, [this.priceEl, this.metaEl]),
      this.addBtn
    ]);

    var side = h('div', { class: 'by-side' }, [tools, this.colorLabel, this.paletteEl, tabBar, this.panel, finish]);
    var main = h('div', { class: 'by-main' }, [h('div', { class: 'by-stage-wrap' }, [this.stage, this.info]), side]);
    root.appendChild(header);
    root.appendChild(main);
    root.appendChild(bar);
    this.setTool('draw');
    this.updateMirrorBtn();
    this.openTab('templates');
    this.bindCanvas();
    var ro = g.ResizeObserver ? new g.ResizeObserver(function () { self.resize(); }) : null;
    if (ro) ro.observe(this.stage); else g.addEventListener('resize', function () { self.resize(); });
    g.addEventListener('keydown', function (e) { self.onKey(e); });
  };

  P.renderPalette = function () {
    var self = this;
    this.paletteEl.innerHTML = '';
    var list = this.showAll ? this.allColors : this.palette;
    list.forEach(function (c) {
      var sw = h('button', { class: 'by-swatch' + (c.light ? ' by-swatch--light' : ''), type: 'button', role: 'option', title: c.name + ' (' + c.code + ')',
        'aria-label': c.name, 'aria-selected': c.id === self.color ? 'true' : 'false', style: { background: c.hex },
        onclick: function () { self.setColor(c.id); } });
      self.paletteEl.appendChild(sw);
    });
    if (this.allColors.length > this.palette.length) {
      this.paletteEl.appendChild(h('button', { class: 'by-swatch-more', type: 'button', text: this.showAll ? 'Fewer' : 'All colors', onclick: function () { self.showAll = !self.showAll; self.renderPalette(); } }));
    }
    var cur = BY.perlerById(this.color);
    this.colorLabel.innerHTML = '';
    if (cur) this.colorLabel.appendChild(h('span', {}, [h('i', { style: { background: cur.hex } }), cur.name + ' ', h('small', { text: cur.code })]));
  };

  P.setColor = function (id) {
    this.color = id;
    if (this.tool === 'erase' || this.tool === 'pick') this.setTool('draw');
    this.recent = [id].concat(this.recent.filter(function (r) { return r !== id; })).slice(0, 8);
    this.renderPalette();
  };
  P.setTool = function (t) {
    this.tool = t;
    var self = this;
    Object.keys(this.toolBtns).forEach(function (k) { self.toolBtns[k].setAttribute('aria-pressed', k === t ? 'true' : 'false'); });
    this.canvas.style.cursor = t === 'pick' ? 'copy' : 'crosshair';
  };
  P.cycleMirror = function () {
    var order = ['off', 'x', 'y', 'xy'];
    this.mirror = order[(order.indexOf(this.mirror) + 1) % order.length];
    this.updateMirrorBtn();
    this.draw();
  };
  P.updateMirrorBtn = function () {
    var label = { off: 'Mirror', x: 'Mirror L|R', y: 'Mirror top/bottom', xy: 'Mirror 4-way' }[this.mirror];
    this.mirrorBtn.querySelector('span:last-child').textContent = label;
    this.mirrorBtn.setAttribute('aria-pressed', this.mirror === 'off' ? 'false' : 'true');
  };

  P.renderAddons = function () {
    var self = this;
    this.addonsEl.innerHTML = '';
    if (!this.cfg.addons || !this.cfg.addons.length) return;
    this.addonsEl.appendChild(h('span', { class: 'by-addons-label', text: 'Add-ons:' }));
    this.cfg.addons.forEach(function (a) {
      var v = self.addonVariant(a);
      var price = v ? ' +' + BY.money(v.price) : '';
      var chip = h('button', { class: 'by-chip', type: 'button', 'aria-pressed': self.addonsOn[a.key] ? 'true' : 'false', text: a.label + price,
        onclick: function () { self.addonsOn[a.key] = !self.addonsOn[a.key]; self.renderAddons(); self.updatePrice(); self.save(); } });
      if (self.products.addons && !v) chip.disabled = true;
      self.addonsEl.appendChild(chip);
    });
  };

  /* ---------------------------------------------------------------- tabs */
  P.openTab = function (name) {
    var self = this;
    Object.keys(this.tabs).forEach(function (k) { self.tabs[k].setAttribute('aria-selected', k === name ? 'true' : 'false'); });
    this.panel.innerHTML = '';
    this.currentTab = name;
    if (name === 'templates') this.panelTemplates();
    else if (name === 'pets') this.panelPets();
    else if (name === 'text') this.panelText();
    else if (name === 'photo') this.panelPhoto();
  };

  // Ask how to use a picked design: replace board or add to current one
  P.placeChoice = function (src, title, category) {
    var self = this, empty = !this.countBeads();
    if (category) this.pendingCategory = category;
    var scale = 1;
    var maxScale = Math.max(1, Math.floor(Math.min(this.w / src.w, this.h / src.h)));
    function apply(mode) {
      var s = BY.clamp(scale, 1, Math.max(1, Math.floor(Math.min(MAX_SIDE / src.w, MAX_SIDE / src.h))));
      var sw = src.w * s, sh = src.h * s, scaled = new Uint8Array(sw * sh);
      for (var y = 0; y < sh; y++) for (var x = 0; x < sw; x++) scaled[y * sw + x] = src.grid[Math.floor(y / s) * src.w + Math.floor(x / s)];
      self.snapshot();
      if (mode === 'replace') {
        var nw = Math.max(self.w, sw), nh = Math.max(self.h, sh);
        if (nw !== self.w || nh !== self.h) { self.w = nw; self.h = nh; self.syncBoardSelect(); }
        self.grid = new Uint8Array(self.w * self.h);
      } else if (sw > self.w || sh > self.h) {
        self.resizeBoard(Math.max(self.w, sw), Math.max(self.h, sh), true);
      }
      BY.stamp(self.grid, self.w, self.h, scaled, sw, sh, Math.floor((self.w - sw) / 2), Math.floor((self.h - sh) / 2));
      if (self.pendingCategory) { self.category = self.pendingCategory; self.pendingCategory = null; }
      self.changed(); self.fit();
      BY.toast(title ? title + ' added' : 'Added');
    }
    var scaleRow = null;
    if (maxScale > 1) {
      var sel = h('select', { class: 'by-select by-select--sm', 'aria-label': 'Size', onchange: function () { scale = +this.value; } });
      for (var s = 1; s <= Math.min(maxScale, 4); s++) sel.appendChild(h('option', { value: String(s), text: s === 1 ? 'Actual size (' + src.w + 'x' + src.h + ')' : s + 'x bigger (' + src.w * s + 'x' + src.h * s + ')' }));
      scaleRow = h('label', { class: 'by-field' }, [h('span', { text: 'Size' }), sel]);
    }
    if (empty) { // nothing to lose: just place it (still allow size choice)
      this.sheet(title || 'Use this design', [
        scaleRow,
        h('div', { class: 'by-row' }, [h('button', { class: 'by-btn by-btn--primary', type: 'button', text: 'Put it on my board', onclick: function () { self.closeSheet(); apply('replace'); } })])
      ]);
      return;
    }
    this.sheet(title || 'Use this design', [
      h('p', { class: 'by-muted', text: 'Your board already has beads. Start fresh with this, or add it to the middle of your design?' }),
      scaleRow,
      h('div', { class: 'by-row' }, [
        h('button', { class: 'by-btn by-btn--primary', type: 'button', text: 'Start fresh', onclick: function () { self.closeSheet(); apply('replace'); } }),
        h('button', { class: 'by-btn', type: 'button', text: 'Add to my design', onclick: function () { self.closeSheet(); apply('add'); } })
      ])
    ]);
  };

  P.panelTemplates = function () {
    var self = this, cats = BY.TPL_CATS || [], current = this.tplCat || 'all';
    var chips = h('div', { class: 'by-chips' });
    [['all', 'All']].concat(cats).forEach(function (c) {
      chips.appendChild(h('button', { class: 'by-chip', type: 'button', 'aria-pressed': c[0] === current ? 'true' : 'false', text: c[1],
        onclick: function () { self.tplCat = c[0]; self.openTab('templates'); } }));
    });
    var grid = h('div', { class: 'by-thumbs' });
    var list = (BY.TEMPLATES || []).filter(function (t) { return current === 'all' || t.cat === current; });
    if (current === 'all' || current === 'pets') {
      (BY.PET_PRESETS || []).forEach(function (p) { list.push({ pet: p, name: p.name, cat: 'pets' }); });
    }
    list.forEach(function (t) {
      var d = t.pet ? BY.composePet(t.pet) : BY.templateGrid(t);
      var img = h('img', { alt: '', loading: 'lazy', src: BY.perlerThumb(d.w, d.h, d.grid, 96, { mode: 'beads' }) });
      grid.appendChild(h('button', { class: 'by-thumb', type: 'button', title: t.name, onclick: function () { self.placeChoice(d, t.name, t.cat); } }, [img, h('span', { text: t.name })]));
    });
    this.panel.appendChild(h('p', { class: 'by-muted', text: 'Pick a starting point, then change any bead you like.' }));
    this.panel.appendChild(chips);
    this.panel.appendChild(grid);
  };

  P.colorWell = function (label, code, onPick) {
    var self = this;
    var c = BY.perlerByCode(code);
    var btn = h('button', { class: 'by-well', type: 'button', 'aria-label': label + ': ' + (c ? c.name : ''), onclick: function () {
      self.pickColor(code, function (picked) { onPick(picked.code); });
    } }, [h('i', { style: { background: c ? c.hex : 'transparent' } }), h('span', { text: label })]);
    return btn;
  };
  P.pickColor = function (currentCode, cb) {
    var self = this;
    var wrap = h('div', { class: 'by-palette by-palette--sheet' });
    this.allColors.forEach(function (c) {
      wrap.appendChild(h('button', { class: 'by-swatch' + (c.light ? ' by-swatch--light' : ''), type: 'button', title: c.name, 'aria-label': c.name,
        'aria-selected': c.code === currentCode ? 'true' : 'false', style: { background: c.hex }, onclick: function () { self.closeSheet(); cb(c); } }));
    });
    this.sheet('Pick a color', [wrap]);
  };

  P.panelPets = function () {
    var self = this;
    if (!this.pet) this.pet = Object.assign({}, BY.PET_PRESETS[0]);
    var pet = this.pet;
    var preview = h('img', { class: 'by-pet-preview', alt: 'Pet preview' });
    function refresh() {
      var d = BY.composePet(pet);
      preview.src = BY.perlerThumb(d.w, d.h, d.grid, 220, { full: true, mode: 'beads' });
      self.petDesign = d;
    }
    var species = h('div', { class: 'by-seg' });
    ['dog', 'cat'].forEach(function (s) {
      species.appendChild(h('button', { class: 'by-seg-btn', type: 'button', 'aria-pressed': pet.species === s ? 'true' : 'false', text: s === 'dog' ? 'Dog' : 'Cat',
        onclick: function () {
          var first = BY.PET_PRESETS.filter(function (p) { return p.species === s; })[0];
          self.pet = Object.assign({}, first); self.openTab('pets');
        } }));
    });
    var breed = h('select', { class: 'by-select', 'aria-label': 'Breed or look', onchange: function () {
      var p = BY.PET_PRESETS.filter(function (x) { return x.id === this.value; }, this)[0];
      if (p) { self.pet = Object.assign({}, p); self.openTab('pets'); }
    } });
    BY.PET_PRESETS.filter(function (p) { return p.species === pet.species; }).forEach(function (p) {
      breed.appendChild(h('option', { value: p.id, text: p.name, selected: p.id === pet.id }));
    });
    var ears = h('select', { class: 'by-select', 'aria-label': 'Ears', onchange: function () { pet.ears = this.value; refresh(); } });
    BY.PET_EARS[pet.species].forEach(function (e) { ears.appendChild(h('option', { value: e, text: BY.PET_EAR_NAMES[e], selected: e === pet.ears })); });
    var mark = h('select', { class: 'by-select', 'aria-label': 'Markings', onchange: function () { pet.mark = this.value; refresh(); } });
    BY.PET_MARKS[pet.species].forEach(function (m) { mark.appendChild(h('option', { value: m, text: BY.PET_MARK_NAMES[m], selected: m === pet.mark })); });
    var wells = h('div', { class: 'by-wells' });
    function well(label, key, fallback) {
      wells.appendChild(self.colorWell(label, pet[key] || fallback, function (code) { pet[key] = code; self.openTab('pets'); }));
    }
    well('Coat', 'base'); well('Muzzle', 'muzzle', pet.base); well('Ears', 'ear', pet.base);
    well('Markings', 'mark1', 'P01');
    if (pet.mark === 'calico') well('Patches 2', 'mark2', 'P18');
    well('Eyes', 'eye', pet.species === 'cat' ? 'P80' : 'P18');
    refresh();
    this.panel.appendChild(h('p', { class: 'by-muted', text: 'Build your pet: pick the closest breed, then change ears, markings and colors. You can still edit any bead after.' }));
    this.panel.appendChild(h('div', { class: 'by-pet' }, [
      preview,
      h('div', { class: 'by-pet-controls' }, [
        species,
        h('label', { class: 'by-field' }, [h('span', { text: 'Breed / look' }), breed]),
        h('label', { class: 'by-field' }, [h('span', { text: 'Ears' }), ears]),
        h('label', { class: 'by-field' }, [h('span', { text: 'Markings' }), mark]),
        wells
      ])
    ]));
    this.panel.appendChild(h('div', { class: 'by-row' }, [
      h('button', { class: 'by-btn by-btn--primary', type: 'button', text: 'Use this pet', onclick: function () { self.placeChoice(self.petDesign, (pet.name || 'Pet'), 'pets'); } }),
      h('button', { class: 'by-btn', type: 'button', text: 'Use my pet\'s photo instead', onclick: function () { self.openTab('photo'); } })
    ]));
  };

  P.panelText = function () {
    var self = this;
    var st = this.textState || (this.textState = { text: '', font: 'regular', scale: 1, outline: '' });
    var preview = h('img', { class: 'by-text-preview', alt: '' });
    var ta = h('textarea', { class: 'by-input', rows: '2', maxlength: '40', placeholder: 'Type a name or word (2 lines max)', 'aria-label': 'Text' });
    ta.value = st.text;
    var font = h('select', { class: 'by-select', 'aria-label': 'Letter style', onchange: function () { st.font = this.value; refresh(); } });
    Object.keys(BY.FONTS).forEach(function (k) { font.appendChild(h('option', { value: k, text: BY.FONTS[k].name + (k === 'small' ? ' (3x5)' : ' (5x7)'), selected: k === st.font })); });
    var scale = h('select', { class: 'by-select', 'aria-label': 'Letter size', onchange: function () { st.scale = +this.value; refresh(); } });
    [1, 2, 3].forEach(function (s) { scale.appendChild(h('option', { value: String(s), text: s === 1 ? 'Normal' : s + 'x tall', selected: s === st.scale })); });
    var outline = h('select', { class: 'by-select', 'aria-label': 'Outline', onchange: function () { st.outline = this.value; refresh(); } });
    outline.appendChild(h('option', { value: '', text: 'No outline' }));
    this.palette.forEach(function (c) { outline.appendChild(h('option', { value: c.code, text: 'Outline: ' + c.name, selected: c.code === st.outline })); });
    function build() {
      var lines = st.text.split('\n').slice(0, 2).join('\n');
      var bm = BY.rasterText(lines, st.font, { scale: st.scale });
      var pad = st.outline ? 1 : 0, W = bm.w + pad * 2, H = bm.h + pad * 2, grid = new Uint8Array(W * H);
      var fill = self.color, out = st.outline ? BY.perlerId(st.outline) : 0;
      if (out) {
        for (var y = 0; y < bm.h; y++) for (var x = 0; x < bm.w; x++) if (bm.bits[y * bm.w + x]) {
          for (var dy = -1; dy <= 1; dy++) for (var dx = -1; dx <= 1; dx++) grid[(y + pad + dy) * W + (x + pad + dx)] = out;
        }
      }
      for (var y2 = 0; y2 < bm.h; y2++) for (var x2 = 0; x2 < bm.w; x2++) if (bm.bits[y2 * bm.w + x2]) grid[(y2 + pad) * W + (x2 + pad)] = fill;
      return { w: W, h: H, grid: grid };
    }
    function refresh() {
      st.text = ta.value.toUpperCase();
      if (!st.text.trim()) { preview.removeAttribute('src'); preview.style.visibility = 'hidden'; return; }
      var d = build();
      preview.style.visibility = 'visible';
      preview.src = BY.perlerThumb(d.w, d.h, d.grid, 260, { full: true, mode: 'beads', pad: 1 });
      sizeNote.textContent = d.w + ' x ' + d.h + ' beads';
    }
    var sizeNote = h('div', { class: 'by-muted by-small' });
    ta.addEventListener('input', refresh);
    var cur = BY.perlerById(this.color);
    this.panel.appendChild(h('p', { class: 'by-muted', html: 'Letters use your selected color' + (cur ? ' (<b>' + cur.name + '</b>)' : '') + '. Pick a different color above first if you like.' }));
    this.panel.appendChild(ta);
    this.panel.appendChild(h('div', { class: 'by-grid2' }, [
      h('label', { class: 'by-field' }, [h('span', { text: 'Style' }), font]),
      h('label', { class: 'by-field' }, [h('span', { text: 'Size' }), scale]),
      h('label', { class: 'by-field by-span2' }, [h('span', { text: 'Outline' }), outline])
    ]));
    this.panel.appendChild(preview);
    this.panel.appendChild(sizeNote);
    this.panel.appendChild(h('div', { class: 'by-row' }, [
      h('button', { class: 'by-btn by-btn--primary', type: 'button', text: 'Add text to board', onclick: function () {
        if (!ta.value.trim()) { BY.toast('Type some text first'); return; }
        var d = build(); self.placeChoice(d, '"' + st.text.replace(/\n/g, ' ') + '"');
      } }),
      h('button', { class: 'by-btn', type: 'button', text: 'Text-only design', onclick: function () {
        if (!ta.value.trim()) { BY.toast('Type some text first'); return; }
        var d = build(); self.snapshot();
        self.w = BY.clamp(d.w + 2, 5, MAX_SIDE); self.h = BY.clamp(d.h + 2, 5, MAX_SIDE); self.grid = new Uint8Array(self.w * self.h);
        BY.stamp(self.grid, self.w, self.h, d.grid, d.w, d.h, 1, 1);
        self.syncBoardSelect(); self.changed(); self.fit();
      } })
    ]));
    refresh();
  };

  P.panelPhoto = function () {
    var self = this;
    var st = this.photoState || (this.photoState = { width: 29, colors: 12, removeBg: true, tol: 12, dither: false, crop: 'square', bright: 0, contrast: 0, cleanup: true });
    var file = h('input', { type: 'file', accept: 'image/*', class: 'by-file', 'aria-label': 'Choose a photo' });
    var srcPrev = h('img', { class: 'by-photo-src', alt: 'Your photo' });
    var outPrev = h('img', { class: 'by-photo-out', alt: 'Bead pattern preview' });
    var stats = h('div', { class: 'by-muted by-small' });
    function slider(label, key, min, max, step, fmt) {
      var val = h('b', { text: fmt ? fmt(st[key]) : String(st[key]) });
      var inp = h('input', { type: 'range', min: String(min), max: String(max), step: String(step || 1), value: String(st[key]), 'aria-label': label,
        oninput: function () { st[key] = +this.value; val.textContent = fmt ? fmt(st[key]) : this.value; schedule(); } });
      return h('label', { class: 'by-field by-range' }, [h('span', {}, [label + ' ', val]), inp]);
    }
    function toggle(label, key) {
      var cb = h('input', { type: 'checkbox', checked: st[key], onchange: function () { st[key] = this.checked; schedule(); } });
      return h('label', { class: 'by-check' }, [cb, h('span', { text: label })]);
    }
    var crop = h('select', { class: 'by-select', 'aria-label': 'Crop', onchange: function () { st.crop = this.value; schedule(); } });
    [['square', 'Square (center)'], ['original', 'Whole photo']].forEach(function (o) { crop.appendChild(h('option', { value: o[0], text: o[1], selected: o[0] === st.crop })); });
    var timer = null;
    function schedule() { clearTimeout(timer); timer = setTimeout(run, 120); }
    function run() {
      if (!self.photoImg) return;
      var res = BY.photoToPattern(self.photoImg, Object.assign({}, st, { palette: self.palette }));
      self.photoResult = res;
      outPrev.src = BY.perlerThumb(res.w, res.h, res.grid, 300, { full: true, mode: 'beads', pad: 0 });
      var n = 0; for (var i = 0; i < res.grid.length; i++) if (res.grid[i]) n++;
      stats.textContent = res.w + ' x ' + res.h + ' board - ' + n + ' beads - ' + BY.perlerCounts(res.grid).length + ' colors';
      useBtn.disabled = false;
    }
    file.addEventListener('change', function () {
      var f = file.files && file.files[0];
      if (!f) return;
      var url = URL.createObjectURL(f), img = new Image();
      img.onload = function () { self.photoImg = img; srcPrev.src = url; srcPrev.style.display = 'block'; run(); };
      img.onerror = function () { BY.toast('Could not read that image', 'error'); };
      img.src = url;
    });
    var useBtn = h('button', { class: 'by-btn by-btn--primary', type: 'button', text: 'Use this pattern', disabled: true, onclick: function () {
      if (!self.photoResult) return;
      var r = self.photoResult;
      self.snapshot(); self.w = r.w; self.h = r.h; self.grid = new Uint8Array(r.grid); self.category = 'photo'; self.syncBoardSelect(); self.changed(); self.fit();
      BY.toast('Pattern placed - touch up any beads you like');
    } });
    if (this.photoImg) { srcPrev.src = this.photoImg.src; srcPrev.style.display = 'block'; }
    this.panel.appendChild(h('p', { class: 'by-muted', text: 'Turn a photo of your pet (or anything) into a bead pattern. Plain backgrounds and close-up faces work best. Your photo stays on your device.' }));
    this.panel.appendChild(h('label', { class: 'by-btn by-file-btn' }, ['Choose photo', file]));
    this.panel.appendChild(h('div', { class: 'by-photo' }, [srcPrev, outPrev]));
    this.panel.appendChild(stats);
    this.panel.appendChild(h('div', { class: 'by-grid2' }, [
      slider('Width in beads', 'width', 10, 58, 1),
      slider('Max colors', 'colors', 2, 30, 1),
      h('label', { class: 'by-field' }, [h('span', { text: 'Crop' }), crop]),
      slider('Background cut', 'tol', 4, 30, 1),
      slider('Brightness', 'bright', -40, 40, 2),
      slider('Contrast', 'contrast', -40, 40, 2),
      toggle('Remove background', 'removeBg'),
      toggle('Clean up stray beads', 'cleanup'),
      toggle('Dither (blend shades)', 'dither')
    ]));
    this.panel.appendChild(h('div', { class: 'by-row' }, [useBtn]));
    if (this.photoImg) run();
  };

  /* ---------------------------------------------------------------- sheets */
  P.sheet = function (title, kids) {
    this.closeSheet();
    var self = this;
    var box = h('div', { class: 'by-sheet', role: 'dialog', 'aria-modal': 'true', 'aria-label': title }, [
      h('div', { class: 'by-sheet-head' }, [h('strong', { text: title }), h('button', { class: 'by-x', type: 'button', 'aria-label': 'Close', text: '×', onclick: function () { self.closeSheet(); } })])
    ].concat(kids.filter(Boolean)));
    var back = h('div', { class: 'by-sheet-back', onclick: function (e) { if (e.target === back) self.closeSheet(); } }, [box]);
    this.root.appendChild(back);
    this.sheetEl = back;
    var f = box.querySelector('button.by-btn, select, input'); if (f) f.focus();
  };
  P.closeSheet = function () { if (this.sheetEl) { this.sheetEl.remove(); this.sheetEl = null; } };
  P.confirm = function (msg, okText, cb) {
    var self = this;
    this.sheet(msg, [h('div', { class: 'by-row' }, [
      h('button', { class: 'by-btn by-btn--primary', type: 'button', text: okText || 'OK', onclick: function () { self.closeSheet(); cb(); } }),
      h('button', { class: 'by-btn', type: 'button', text: 'Cancel', onclick: function () { self.closeSheet(); } })
    ])]);
  };

  /* ---------------------------------------------------------------- board */
  P.onBoardChange = function (val) {
    var self = this;
    if (val === 'custom') {
      var wIn = h('input', { class: 'by-input', type: 'number', min: '5', max: String(MAX_SIDE), value: String(this.w), 'aria-label': 'Width in beads' });
      var hIn = h('input', { class: 'by-input', type: 'number', min: '5', max: String(MAX_SIDE), value: String(this.h), 'aria-label': 'Height in beads' });
      this.sheet('Custom board size', [
        h('div', { class: 'by-grid2' }, [h('label', { class: 'by-field' }, [h('span', { text: 'Width (beads)' }), wIn]), h('label', { class: 'by-field' }, [h('span', { text: 'Height (beads)' }), hIn])]),
        h('p', { class: 'by-muted by-small', text: 'Each bead is about 5 mm (0.2"). Max ' + MAX_SIDE + ' x ' + MAX_SIDE + '.' }),
        h('div', { class: 'by-row' }, [h('button', { class: 'by-btn by-btn--primary', type: 'button', text: 'Set size', onclick: function () {
          var nw = BY.clamp(parseInt(wIn.value, 10) || self.w, 5, MAX_SIDE), nh = BY.clamp(parseInt(hIn.value, 10) || self.h, 5, MAX_SIDE);
          self.closeSheet(); self.trySize(nw, nh);
        } })])
      ]);
      this.syncBoardSelect();
      return;
    }
    var b = BOARDS.filter(function (x) { return x.id === val; })[0];
    if (b) this.trySize(b.w, b.h);
  };
  P.trySize = function (nw, nh) {
    var self = this, bb = BY.perlerBounds(this.w, this.h, this.grid);
    if (bb && (bb.w > nw || bb.h > nh)) {
      this.confirm('Some beads will be cut off at ' + nw + ' x ' + nh + '. Resize anyway?', 'Resize', function () { self.snapshot(); self.resizeBoard(nw, nh); self.changed(); self.fit(); });
      this.syncBoardSelect();
      return;
    }
    this.snapshot(); this.resizeBoard(nw, nh); this.changed(); this.fit();
  };
  // Resize keeping the design centered
  P.resizeBoard = function (nw, nh, noSync) {
    var ow = this.w, oh = this.h, old = this.grid, ng = new Uint8Array(nw * nh);
    var bb = BY.perlerBounds(ow, oh, old);
    var dx, dy;
    if (bb) { dx = Math.floor((nw - bb.w) / 2) - bb.x; dy = Math.floor((nh - bb.h) / 2) - bb.y; }
    else { dx = 0; dy = 0; }
    for (var y = 0; y < oh; y++) for (var x = 0; x < ow; x++) {
      var v = old[y * ow + x]; if (!v) continue;
      var X = x + dx, Y = y + dy;
      if (X >= 0 && Y >= 0 && X < nw && Y < nh) ng[Y * nw + X] = v;
    }
    this.w = nw; this.h = nh; this.grid = ng;
    if (!noSync) this.syncBoardSelect();
  };
  P.syncBoardSelect = function () {
    var self = this;
    var b = BOARDS.filter(function (x) { return x.w === self.w && x.h === self.h; })[0];
    var custom = this.boardSel.querySelector('option[value="custom"]');
    if (b) { this.boardSel.value = b.id; custom.textContent = 'Custom size...'; }
    else { custom.textContent = 'Custom - ' + this.w + 'x' + this.h + ' (' + BY.fmtInches(this.w) + ' x ' + BY.fmtInches(this.h) + ')'; this.boardSel.value = 'custom'; }
  };

  /* ---------------------------------------------------------------- history */
  P.snapshot = function () {
    this.undoStack.push({ w: this.w, h: this.h, grid: new Uint8Array(this.grid) });
    if (this.undoStack.length > 120) this.undoStack.shift();
    this.redoStack.length = 0;
  };
  P.undo = function () {
    if (!this.undoStack.length) return;
    this.redoStack.push({ w: this.w, h: this.h, grid: new Uint8Array(this.grid) });
    var s = this.undoStack.pop(); this.w = s.w; this.h = s.h; this.grid = s.grid;
    this.syncBoardSelect(); this.changed();
  };
  P.redo = function () {
    if (!this.redoStack.length) return;
    this.undoStack.push({ w: this.w, h: this.h, grid: new Uint8Array(this.grid) });
    var s = this.redoStack.pop(); this.w = s.w; this.h = s.h; this.grid = s.grid;
    this.syncBoardSelect(); this.changed();
  };

  /* ---------------------------------------------------------------- painting */
  P.cellAt = function (clientX, clientY) {
    var r = this.canvas.getBoundingClientRect();
    var x = (clientX - r.left - this.ox) / this.cell, y = (clientY - r.top - this.oy) / this.cell;
    return { x: Math.floor(x), y: Math.floor(y) };
  };
  P.setCell = function (x, y, v) {
    var self = this;
    var pts = [[x, y]];
    if (this.mirror === 'x' || this.mirror === 'xy') pts.push([this.w - 1 - x, y]);
    if (this.mirror === 'y' || this.mirror === 'xy') pts.push([x, this.h - 1 - y]);
    if (this.mirror === 'xy') pts.push([this.w - 1 - x, this.h - 1 - y]);
    pts.forEach(function (p) { if (p[0] >= 0 && p[1] >= 0 && p[0] < self.w && p[1] < self.h) self.grid[p[1] * self.w + p[0]] = v; });
  };
  P.line = function (x0, y0, x1, y1, v) {
    var dx = Math.abs(x1 - x0), dy = -Math.abs(y1 - y0), sx = x0 < x1 ? 1 : -1, sy = y0 < y1 ? 1 : -1, err = dx + dy;
    for (var guard = 0; guard < 2000; guard++) {
      this.setCell(x0, y0, v);
      if (x0 === x1 && y0 === y1) break;
      var e2 = 2 * err;
      if (e2 >= dy) { err += dy; x0 += sx; }
      if (e2 <= dx) { err += dx; y0 += sy; }
    }
  };
  P.flood = function (x, y, v) {
    var w = this.w, hh = this.h, g2 = this.grid, target = g2[y * w + x];
    if (target === v) return;
    var stack = [x + y * w], seen = new Uint8Array(w * hh);
    while (stack.length) {
      var i = stack.pop();
      if (seen[i]) continue; seen[i] = 1;
      if (g2[i] !== target) continue;
      g2[i] = v;
      var cx = i % w, cy = (i - cx) / w;
      if (cx > 0) stack.push(i - 1); if (cx < w - 1) stack.push(i + 1);
      if (cy > 0) stack.push(i - w); if (cy < hh - 1) stack.push(i + w);
    }
  };

  P.bindCanvas = function () {
    var self = this, cv = this.canvas, pointers = new Map(), stroke = null, pinch = null;
    cv.style.touchAction = 'none';
    function startPinch() {
      var ps = Array.from(pointers.values());
      var d = Math.hypot(ps[0].x - ps[1].x, ps[0].y - ps[1].y);
      pinch = { d: d, zoom: self.zoom, cx: (ps[0].x + ps[1].x) / 2, cy: (ps[0].y + ps[1].y) / 2, panX: self.panX, panY: self.panY };
    }
    cv.addEventListener('pointerdown', function (e) {
      cv.setPointerCapture(e.pointerId);
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pointers.size === 2) {
        if (stroke && stroke.changed) { self.undo(); self.redoStack.length = 0; }
        stroke = null; startPinch(); return;
      }
      if (pointers.size > 2) return;
      if (e.button === 1 || e.button === 2 || self.spaceDown) { stroke = { pan: true, x: e.clientX, y: e.clientY, panX: self.panX, panY: self.panY }; return; }
      var c = self.cellAt(e.clientX, e.clientY);
      if (c.x < 0 || c.y < 0 || c.x >= self.w || c.y >= self.h) { stroke = { pan: true, x: e.clientX, y: e.clientY, panX: self.panX, panY: self.panY }; return; }
      if (self.tool === 'pick') {
        var v = self.grid[c.y * self.w + c.x];
        if (v) { self.setColor(v); BY.toast('Picked ' + BY.perlerById(v).name); }
        return;
      }
      self.snapshot();
      if (self.tool === 'fill') { self.flood(c.x, c.y, self.color); self.changed(); return; }
      var val = self.tool === 'erase' ? 0 : self.color;
      // tapping a bead that already has the selected color removes it (quick toggle)
      if (self.tool === 'draw' && self.grid[c.y * self.w + c.x] === self.color && e.pointerType !== 'mouse') val = 0;
      stroke = { val: val, last: c, changed: true };
      self.setCell(c.x, c.y, val); self.changed(true);
    });
    cv.addEventListener('pointermove', function (e) {
      if (pointers.has(e.pointerId)) pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pinch && pointers.size === 2) {
        var ps = Array.from(pointers.values());
        var d = Math.hypot(ps[0].x - ps[1].x, ps[0].y - ps[1].y);
        var cx = (ps[0].x + ps[1].x) / 2, cy = (ps[0].y + ps[1].y) / 2;
        self.zoom = BY.clamp(pinch.zoom * d / pinch.d, 0.6, 12);
        self.panX = pinch.panX + (cx - pinch.cx); self.panY = pinch.panY + (cy - pinch.cy);
        self.draw(); return;
      }
      if (!stroke) { self.hover = self.cellAt(e.clientX, e.clientY); if (e.pointerType === 'mouse') self.draw(); return; }
      if (stroke.pan) { self.panX = stroke.panX + (e.clientX - stroke.x); self.panY = stroke.panY + (e.clientY - stroke.y); self.draw(); return; }
      var c = self.cellAt(e.clientX, e.clientY);
      if (c.x === stroke.last.x && c.y === stroke.last.y) return;
      self.line(stroke.last.x, stroke.last.y, c.x, c.y, stroke.val);
      stroke.last = c; self.changed(true);
    });
    function end(e) {
      pointers.delete(e.pointerId);
      if (pointers.size < 2) pinch = null;
      if (stroke && !stroke.pan) self.changed();
      if (pointers.size === 0) stroke = null;
    }
    cv.addEventListener('pointerup', end);
    cv.addEventListener('pointercancel', end);
    cv.addEventListener('pointerleave', function () { self.hover = null; self.draw(); });
    cv.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    cv.addEventListener('wheel', function (e) {
      e.preventDefault();
      var r = cv.getBoundingClientRect(), mx = e.clientX - r.left, my = e.clientY - r.top;
      var f = Math.exp(-e.deltaY * 0.0015), nz = BY.clamp(self.zoom * f, 0.6, 12), k = nz / self.zoom;
      // keep the point under the cursor fixed
      var baseX = (r.width - self.w * self.baseCell * self.zoom) / 2, baseY = (r.height - self.h * self.baseCell * self.zoom) / 2;
      var ox = baseX + self.panX, oy = baseY + self.panY;
      var nbx = (r.width - self.w * self.baseCell * nz) / 2, nby = (r.height - self.h * self.baseCell * nz) / 2;
      self.panX = mx - (mx - ox) * k - nbx; self.panY = my - (my - oy) * k - nby;
      self.zoom = nz; self.draw();
    }, { passive: false });
  };

  P.onKey = function (e) {
    var tag = (e.target && e.target.tagName) || '';
    if (/INPUT|TEXTAREA|SELECT/.test(tag)) return;
    if (!this.root.isConnected) return;
    var k = e.key.toLowerCase();
    if ((e.ctrlKey || e.metaKey) && k === 'z') { e.preventDefault(); if (e.shiftKey) this.redo(); else this.undo(); return; }
    if ((e.ctrlKey || e.metaKey) && k === 'y') { e.preventDefault(); this.redo(); return; }
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    if (k === 'd' || k === 'b') this.setTool('draw');
    else if (k === 'e') this.setTool('erase');
    else if (k === 'f' || k === 'g') this.setTool('fill');
    else if (k === 'i') this.setTool('pick');
    else if (k === 'm') this.cycleMirror();
    else if (k === ' ') { this.spaceDown = true; }
  };

  /* ---------------------------------------------------------------- render */
  P.resize = function () {
    var r = this.stage.getBoundingClientRect(), dpr = g.devicePixelRatio || 1;
    if (!r.width || !r.height) return;
    this.canvas.width = Math.round(r.width * dpr); this.canvas.height = Math.round(r.height * dpr);
    this.canvas.style.width = r.width + 'px'; this.canvas.style.height = r.height + 'px';
    this.dpr = dpr; this.cssW = r.width; this.cssH = r.height;
    this.draw();
  };
  P.fit = function () { this.zoom = 1; this.panX = 0; this.panY = 0; this.draw(); };
  P.zoomBy = function (f) { this.zoom = BY.clamp(this.zoom * f, 0.6, 12); this.draw(); };
  P.draw = function () {
    if (!this.cssW) return;
    var ctx = this.ctx, W = this.cssW, H = this.cssH, pad = 10;
    this.baseCell = Math.max(2, Math.min((W - pad * 2) / this.w, (H - pad * 2) / this.h));
    var cell = this.baseCell * this.zoom;
    this.cell = cell;
    this.ox = (W - this.w * cell) / 2 + this.panX; this.oy = (H - this.h * cell) / 2 + this.panY;
    ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
    ctx.clearRect(0, 0, W, H);
    // board
    ctx.fillStyle = '#f4f2f8';
    var bx = this.ox - 4, by = this.oy - 4, bw = this.w * cell + 8, bh = this.h * cell + 8;
    roundRect(ctx, bx, by, bw, bh, 8); ctx.fill();
    BY.drawPerler(ctx, this.w, this.h, this.grid, { cell: cell, x: this.ox, y: this.oy, mode: this.view === 'pixels' || cell < 6 ? 'pixels' : 'beads', pegs: cell >= 5 });
    // board seams every 29 pegs
    if (this.w > 29 || this.h > 29) {
      ctx.strokeStyle = 'rgba(90,70,140,.35)'; ctx.lineWidth = 1; ctx.setLineDash([4, 4]);
      for (var x = 29; x < this.w; x += 29) { ctx.beginPath(); ctx.moveTo(this.ox + x * cell, this.oy); ctx.lineTo(this.ox + x * cell, this.oy + this.h * cell); ctx.stroke(); }
      for (var y = 29; y < this.h; y += 29) { ctx.beginPath(); ctx.moveTo(this.ox, this.oy + y * cell); ctx.lineTo(this.ox + this.w * cell, this.oy + y * cell); ctx.stroke(); }
      ctx.setLineDash([]);
    }
    if (this.view === 'pixels' && cell >= 6) {
      ctx.strokeStyle = 'rgba(0,0,0,.08)'; ctx.lineWidth = 1;
      ctx.beginPath();
      for (var gx = 0; gx <= this.w; gx++) { ctx.moveTo(this.ox + gx * cell + .5, this.oy); ctx.lineTo(this.ox + gx * cell + .5, this.oy + this.h * cell); }
      for (var gy = 0; gy <= this.h; gy++) { ctx.moveTo(this.ox, this.oy + gy * cell + .5); ctx.lineTo(this.ox + this.w * cell, this.oy + gy * cell + .5); }
      ctx.stroke();
    }
    // mirror guides
    if (this.mirror !== 'off') {
      ctx.strokeStyle = 'rgba(224,66,132,.75)'; ctx.lineWidth = 2; ctx.setLineDash([6, 4]);
      if (this.mirror === 'x' || this.mirror === 'xy') { ctx.beginPath(); ctx.moveTo(this.ox + this.w * cell / 2, this.oy - 6); ctx.lineTo(this.ox + this.w * cell / 2, this.oy + this.h * cell + 6); ctx.stroke(); }
      if (this.mirror === 'y' || this.mirror === 'xy') { ctx.beginPath(); ctx.moveTo(this.ox - 6, this.oy + this.h * cell / 2); ctx.lineTo(this.ox + this.w * cell + 6, this.oy + this.h * cell / 2); ctx.stroke(); }
      ctx.setLineDash([]);
    }
    // hover
    if (this.hover && this.hover.x >= 0 && this.hover.y >= 0 && this.hover.x < this.w && this.hover.y < this.h) {
      ctx.strokeStyle = 'rgba(30,20,50,.6)'; ctx.lineWidth = 1.5;
      ctx.strokeRect(this.ox + this.hover.x * cell + 1, this.oy + this.hover.y * cell + 1, cell - 2, cell - 2);
    }
  };
  function roundRect(ctx, x, y, w, h, r) {
    ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath();
  }

  /* ---------------------------------------------------------------- pricing + cart */
  P.countBeads = function () { var n = 0; for (var i = 0; i < this.grid.length; i++) if (this.grid[i]) n++; return n; };
  P.tierFor = function (n) {
    var t = this.cfg.tiers;
    for (var i = 0; i < t.length; i++) if (n <= t[i].max) return t[i];
    return null;
  };
  P.tierVariant = function (tier) { return tier && this.products.main ? BY.findVariant(this.products.main, [tier.name]) : null; };
  P.addonVariant = function (a) { return this.products.addons ? BY.findVariant(this.products.addons, [a.label]) : null; };
  P.loadProducts = function () {
    var self = this;
    BY.fetchProduct(this.cfg.productHandle).then(function (p) { self.products.main = p; self.updatePrice(); })
      .catch(function () { self.productError = true; self.updatePrice(); });
    if (this.cfg.addons && this.cfg.addons.length) {
      BY.fetchProduct(this.cfg.addonsHandle).then(function (p) { self.products.addons = p; self.renderAddons(); self.updatePrice(); })
        .catch(function () { /* add-ons optional */ });
    }
  };
  P.updatePrice = function () {
    var n = this.countBeads(), tier = this.tierFor(n), v = this.tierVariant(tier);
    var bb = BY.perlerBounds(this.w, this.h, this.grid);
    var colors = BY.perlerCounts(this.grid).length;
    var size = bb ? BY.fmtInches(bb.w) + ' x ' + BY.fmtInches(bb.h) : '';
    this.metaEl.textContent = n ? (n + ' beads - ' + colors + ' color' + (colors === 1 ? '' : 's') + (size ? ' - about ' + size : '') + (tier ? ' - ' + tier.name + ' size' : '')) : 'Tap the board to place beads';
    var total = v ? v.price : null, self = this;
    if (total !== null) (this.cfg.addons || []).forEach(function (a) { if (self.addonsOn[a.key]) { var av = self.addonVariant(a); if (av) total += av.price; } });
    if (!n) this.priceEl.textContent = '';
    else if (!tier) this.priceEl.textContent = 'Too big - max ' + this.cfg.tiers[this.cfg.tiers.length - 1].max + ' beads';
    else if (total !== null) this.priceEl.textContent = BY.money(total);
    else this.priceEl.textContent = this.productError ? 'Price unavailable' : '...';
    this.addBtn.disabled = !(n >= MIN_BEADS && tier && v && v.available !== false);
    this.info.textContent = this.w + ' x ' + this.h + ' board (' + BY.fmtInches(this.w) + ' x ' + BY.fmtInches(this.h) + ')';
  };
  P.addToCart = function () {
    var self = this, n = this.countBeads(), tier = this.tierFor(n), v = this.tierVariant(tier);
    if (n < MIN_BEADS) { BY.toast('Add a few more beads first'); return; }
    if (!v) { BY.toast('This size is not available right now', 'error'); return; }
    var bb = BY.perlerBounds(this.w, this.h, this.grid);
    // store the trimmed design (only the bead area)
    var sub = new Uint8Array(bb.w * bb.h);
    for (var y = 0; y < bb.h; y++) for (var x = 0; x < bb.w; x++) sub[y * bb.w + x] = this.grid[(y + bb.y) * this.w + (x + bb.x)];
    var code = BY.encodePerler(bb.w, bb.h, sub);
    var name = (this.name || '').trim() || 'My Perler design';
    var colors = BY.perlerCounts(sub).length;
    var props = {
      'Design': name,
      'Size': bb.w + ' x ' + bb.h + ' beads (about ' + BY.fmtInches(bb.w) + ' x ' + BY.fmtInches(bb.h) + ')',
      'Beads': n + ' beads, ' + colors + ' color' + (colors === 1 ? '' : 's'),
      '_design': code,
      '_pattern': BY.patternUrl(this.cfg, code)
    };
    BY.shareProps(this, props);
    if (this.category) props._category = this.category;
    var items = [{ id: v.id, quantity: 1, properties: props }];
    (this.cfg.addons || []).forEach(function (a) {
      if (!self.addonsOn[a.key]) return;
      var av = self.addonVariant(a);
      if (av) items.push({ id: av.id, quantity: 1, properties: { 'For design': name } });
    });
    this.addBtn.disabled = true; this.addBtn.textContent = 'Adding...';
    BY.cartAdd(items).then(function () {
      BY.store.del('perler:draft');
      self.addBtn.textContent = 'Added!';
      g.dispatchEvent(new CustomEvent('beadyours:added', { detail: { items: items } }));
      if (self.cfg.afterAdd === 'cart') g.location.href = BY.root() + 'cart';
      else setTimeout(function () { self.addBtn.textContent = 'Add to cart'; self.updatePrice(); }, 1500);
    }).catch(function (err) {
      BY.toast(err.message || 'Could not add to cart', 'error');
      self.addBtn.textContent = 'Add to cart'; self.updatePrice();
    });
  };

  /* ---------------------------------------------------------------- persistence */
  P.changed = function (live) {
    this.draw();
    if (!live) { this.updatePrice(); this.save(); }
    else if (!this._pt) { var self = this; this._pt = setTimeout(function () { self._pt = null; self.updatePrice(); }, 120); }
  };
  P.save = function () {
    var self = this;
    clearTimeout(this._st);
    this._st = setTimeout(function () {
      BY.store.set('perler:draft', { w: self.w, h: self.h, code: BY.encodePerler(self.w, self.h, self.grid), name: self.name, share: self.share, credit: self.credit || '', addons: self.addonsOn, category: self.category || null });
    }, 300);
  };
  P.restore = function () {
    var fromHash = null, m = /design=([^&]+)/.exec(g.location.hash || '');
    if (m) { try { fromHash = BY.decodePerler(decodeURIComponent(m[1])); } catch (e) { fromHash = null; } }
    var nm = /name=([^&]+)/.exec(g.location.hash || '');
    if (fromHash) {
      var nw = Math.max(fromHash.w + 2, 15), nh = Math.max(fromHash.h + 2, 15);
      var fit = BOARDS.filter(function (b) { return b.w >= fromHash.w && b.h >= fromHash.h && b.w === b.h; })[0];
      if (fit) { nw = fit.w; nh = fit.h; }
      this.w = nw; this.h = nh; this.grid = new Uint8Array(nw * nh);
      BY.stamp(this.grid, nw, nh, fromHash.grid, fromHash.w, fromHash.h, Math.floor((nw - fromHash.w) / 2), Math.floor((nh - fromHash.h) / 2));
      if (nm) { this.name = decodeURIComponent(nm[1]); }
      var cm = /cat=([^&]+)/.exec(g.location.hash || ''); if (cm) this.category = decodeURIComponent(cm[1]);
    } else {
      var d = BY.store.get('perler:draft');
      if (d && d.code) {
        try { var dec = BY.decodePerler(d.code); this.w = dec.w; this.h = dec.h; this.grid = dec.grid; } catch (e) { /* ignore broken draft */ }
        this.name = d.name || ''; this.share = !!d.share; this.credit = d.credit || ''; this.addonsOn = d.addons || {}; this.category = d.category || null;
      }
    }
    if (!fromHash && !this.countBeads() && this.cfg.startTemplate) {
      var st = this.cfg.startTemplate, src = null;
      var t = (BY.TEMPLATES || []).filter(function (x) { return x.id === st; })[0];
      var pp = (BY.PET_PRESETS || []).filter(function (x) { return x.id === st; })[0];
      if (t) src = BY.templateGrid(t); else if (pp) src = BY.composePet(pp);
      if (src) BY.stamp(this.grid, this.w, this.h, src.grid, src.w, src.h, Math.floor((this.w - src.w) / 2), Math.floor((this.h - src.h) / 2));
    }
    this.nameInput.value = this.name;
    this.shareUI.sync();
    this.syncBoardSelect(); this.renderAddons(); this.updatePrice();
  };

  /* ---------------------------------------------------------------- photo -> pattern */
  function samplePhoto(img, sx, sy, sw, sh, W, H) {
    var cw = sw, ch = sh, src = img, csx = sx, csy = sy;
    while (cw / 2 > W * 2 && ch / 2 > H * 2) {
      var tmp = document.createElement('canvas'); tmp.width = Math.round(cw / 2); tmp.height = Math.round(ch / 2);
      var tc = tmp.getContext('2d'); tc.imageSmoothingQuality = 'high';
      tc.drawImage(src, csx, csy, cw, ch, 0, 0, tmp.width, tmp.height);
      src = tmp; csx = 0; csy = 0; cw = tmp.width; ch = tmp.height;
    }
    var cv = document.createElement('canvas'), ctx = cv.getContext('2d', { willReadFrequently: true });
    cv.width = W; cv.height = H; ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(src, csx, csy, cw, ch, 0, 0, W, H);
    return ctx.getImageData(0, 0, W, H).data;
  }
  function adjust(data, n, o) {
    var rgb = new Float32Array(n * 3), keep = new Uint8Array(n);
    var b = (o.bright || 0) * 2.55, c = (o.contrast || 0), cf = (259 * (c + 255)) / (255 * (259 - c));
    for (var i = 0; i < n; i++) {
      keep[i] = data[i * 4 + 3] >= 128 ? 1 : 0;
      for (var k = 0; k < 3; k++) rgb[i * 3 + k] = BY.clamp(cf * (data[i * 4 + k] + b - 128) + 128, 0, 255);
    }
    return { rgb: rgb, keep: keep };
  }
  // flood background from the borders; returns bg mask (1 = background)
  function bgMask(rgb, keep, W, H, tol) {
    var n = W * H, labs = new Array(n), bg = new Uint8Array(n);
    for (var i = 0; i < n; i++) labs[i] = BY.color.rgbToLab([rgb[i * 3], rgb[i * 3 + 1], rgb[i * 3 + 2]]);
    var border = [];
    for (var x = 0; x < W; x++) { border.push(x); border.push((H - 1) * W + x); }
    for (var y = 0; y < H; y++) { border.push(y * W); border.push(y * W + W - 1); }
    border.forEach(function (start) {
      if (bg[start] || !keep[start]) return;
      var ref = labs[start], stack = [start], seen = new Uint8Array(n);
      while (stack.length) {
        var p = stack.pop();
        if (seen[p] || bg[p]) continue; seen[p] = 1;
        if (BY.color.deltaE(labs[p], ref) > tol) continue;
        bg[p] = 1;
        var px = p % W, py = (p - px) / W;
        if (px > 0) stack.push(p - 1); if (px < W - 1) stack.push(p + 1);
        if (py > 0) stack.push(p - W); if (py < H - 1) stack.push(p + W);
      }
    });
    for (i = 0; i < n; i++) if (!keep[i]) bg[i] = 1;
    return bg;
  }
  BY.photoToPattern = function (img, o) {
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
    var sx = 0, sy = 0, sw = iw, sh = ih;
    if (o.crop === 'square') { var m = Math.min(iw, ih); sx = (iw - m) / 2; sy = (ih - m) / 2; sw = sh = m; }
    var tol = o.tol || 12;
    if (o.removeBg) {
      // probe pass: find the subject so "width in beads" means the subject's width
      var PW = 72, PH = Math.max(8, Math.round(PW * sh / sw));
      var pd = adjust(samplePhoto(img, sx, sy, sw, sh, PW, PH), PW * PH, o);
      var pm = bgMask(pd.rgb, pd.keep, PW, PH, tol);
      var minX = PW, minY = PH, maxX = -1, maxY = -1;
      for (var yy = 0; yy < PH; yy++) for (var xx = 0; xx < PW; xx++) if (!pm[yy * PW + xx]) {
        if (xx < minX) minX = xx; if (xx > maxX) maxX = xx; if (yy < minY) minY = yy; if (yy > maxY) maxY = yy;
      }
      if (maxX >= 0 && (maxX - minX + 1) * (maxY - minY + 1) > PW * PH * 0.04) {
        minX = Math.max(0, minX - 1); minY = Math.max(0, minY - 1); maxX = Math.min(PW - 1, maxX + 1); maxY = Math.min(PH - 1, maxY + 1);
        var nsx = sx + minX / PW * sw, nsy = sy + minY / PH * sh;
        sw = (maxX - minX + 1) / PW * sw; sh = (maxY - minY + 1) / PH * sh; sx = nsx; sy = nsy;
      }
    }
    var W = BY.clamp(Math.round(o.width), 4, MAX_SIDE), H = BY.clamp(Math.round(W * sh / sw), 4, MAX_SIDE);
    var n = W * H, ad = adjust(samplePhoto(img, sx, sy, sw, sh, W, H), n, o), rgb = ad.rgb, keep = ad.keep;
    var i, x, y, k;
    if (o.removeBg) {
      var bg = bgMask(rgb, keep, W, H, tol);
      // de-fringe: edge pixels that are a blend of subject + background take the subject color
      var fixed = new Float32Array(rgb);
      for (y = 0; y < H; y++) for (x = 0; x < W; x++) {
        i = y * W + x; if (bg[i]) continue;
        var bgN = [], fgN = [];
        for (var dy = -1; dy <= 1; dy++) for (var dx = -1; dx <= 1; dx++) {
          if (!dx && !dy) continue;
          var X = x + dx, Y = y + dy; if (X < 0 || Y < 0 || X >= W || Y >= H) continue;
          var j = Y * W + X;
          if (bg[j]) { if (keep[j]) bgN.push(j); }
          else {
            var interior = true;
            if (X > 0 && bg[j - 1]) interior = false; if (X < W - 1 && bg[j + 1]) interior = false;
            if (Y > 0 && bg[j - W]) interior = false; if (Y < H - 1 && bg[j + W]) interior = false;
            if (interior) fgN.push(j);
          }
        }
        if (!bgN.length || !fgN.length) continue;
        var F = [0, 0, 0], B = [0, 0, 0];
        fgN.forEach(function (q) { for (var t = 0; t < 3; t++) F[t] += rgb[q * 3 + t] / fgN.length; });
        bgN.forEach(function (q) { for (var t = 0; t < 3; t++) B[t] += rgb[q * 3 + t] / bgN.length; });
        var BF = [B[0] - F[0], B[1] - F[1], B[2] - F[2]], PF = [rgb[i * 3] - F[0], rgb[i * 3 + 1] - F[1], rgb[i * 3 + 2] - F[2]];
        var len2 = BF[0] * BF[0] + BF[1] * BF[1] + BF[2] * BF[2]; if (len2 < 400) continue;
        var tt = (PF[0] * BF[0] + PF[1] * BF[1] + PF[2] * BF[2]) / len2;
        var res = Math.hypot(PF[0] - tt * BF[0], PF[1] - tt * BF[1], PF[2] - tt * BF[2]);
        if (tt > 0.6 && res < 45) { keep[i] = 0; continue; }
        if (tt > 0.12 && res < 45) { fixed[i * 3] = F[0]; fixed[i * 3 + 1] = F[1]; fixed[i * 3 + 2] = F[2]; }
      }
      rgb = fixed;
      for (i = 0; i < n; i++) if (bg[i]) keep[i] = 0;
    }
    var pal = o.palette, cache = new Map(), grid = new Uint8Array(n);
    if (o.dither) {
      var buf = new Float32Array(rgb);
      for (y = 0; y < H; y++) for (x = 0; x < W; x++) {
        i = y * W + x; if (!keep[i]) continue;
        var px3 = [BY.clamp(Math.round(buf[i * 3]), 0, 255), BY.clamp(Math.round(buf[i * 3 + 1]), 0, 255), BY.clamp(Math.round(buf[i * 3 + 2]), 0, 255)];
        var best = BY.nearestPerler(px3, pal, cache);
        grid[i] = best.id;
        for (k = 0; k < 3; k++) {
          var err = buf[i * 3 + k] - best.rgb[k];
          if (x + 1 < W && keep[i + 1]) buf[(i + 1) * 3 + k] += err * 7 / 16;
          if (y + 1 < H) {
            if (x > 0 && keep[i + W - 1]) buf[(i + W - 1) * 3 + k] += err * 3 / 16;
            if (keep[i + W]) buf[(i + W) * 3 + k] += err * 5 / 16;
            if (x + 1 < W && keep[i + W + 1]) buf[(i + W + 1) * 3 + k] += err * 1 / 16;
          }
        }
      }
    } else {
      for (i = 0; i < n; i++) if (keep[i]) grid[i] = BY.nearestPerler([Math.round(rgb[i * 3]), Math.round(rgb[i * 3 + 1]), Math.round(rgb[i * 3 + 2])], pal, cache).id;
    }
    // limit number of colors: fold least-used colors into their nearest used neighbor
    var maxC = Math.max(2, o.colors || 12);
    for (var guard = 0; guard < 200; guard++) {
      var counts = BY.perlerCounts(grid);
      if (counts.length <= maxC) break;
      var victim = counts[counts.length - 1].color, bestC = null, bestD = Infinity;
      for (var jj = 0; jj < counts.length - 1; jj++) {
        var d = BY.color.deltaE(victim.lab, counts[jj].color.lab);
        if (d < bestD) { bestD = d; bestC = counts[jj].color; }
      }
      for (i = 0; i < n; i++) if (grid[i] === victim.id) grid[i] = bestC.id;
    }
    if (o.cleanup) {
      var out = new Uint8Array(grid);
      for (y = 0; y < H; y++) for (x = 0; x < W; x++) {
        i = y * W + x; var v = grid[i]; if (!v) continue;
        var nb = [];
        if (x > 0) nb.push(grid[i - 1]); if (x < W - 1) nb.push(grid[i + 1]);
        if (y > 0) nb.push(grid[i - W]); if (y < H - 1) nb.push(grid[i + W]);
        if (nb.filter(function (q) { return q === v; }).length) continue;
        var tally = {}, top = 0, topV = v;
        nb.forEach(function (q) { tally[q] = (tally[q] || 0) + 1; if (tally[q] > top) { top = tally[q]; topV = q; } });
        if (top >= 3) out[i] = topV;
        else if (nb.filter(function (q) { return !q; }).length >= 3) out[i] = 0; // lone bead sticking out
      }
      grid = out;
    }
    var bb = BY.perlerBounds(W, H, grid);
    if (bb && (bb.w < W || bb.h < H)) {
      var tg = new Uint8Array(bb.w * bb.h);
      for (y = 0; y < bb.h; y++) for (x = 0; x < bb.w; x++) tg[y * bb.w + x] = grid[(y + bb.y) * W + (x + bb.x)];
      return { w: bb.w, h: bb.h, grid: tg };
    }
    return { w: W, h: H, grid: grid };
  };

  /* ---------------------------------------------------------------- mount */
  BY.PerlerBuilder = PerlerBuilder;
  BY.mountPerler = function (el) {
    if (el.__byPerler) return el.__byPerler;
    var cfg = BY.readConfig(el);
    el.__byPerler = new PerlerBuilder(el, cfg);
    return el.__byPerler;
  };
  function boot() { document.querySelectorAll('[data-by-perler]').forEach(BY.mountPerler); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  g.addEventListener('keyup', function (e) { if (e.key === ' ') document.querySelectorAll('[data-by-perler]').forEach(function (el) { if (el.__byPerler) el.__byPerler.spaceDown = false; }); });
})(window);
